import { env } from '@altermaind/core/env';
import { Environments } from '../constants';

/**
 * Retrieves the current environment.
 *
 * This function checks the current hostname and environment settings to determine
 * whether the application is running in localhost, development, UAT (User Acceptance Testing),
 * or production environment.
 *
 * @returns {Object} An object containing the following boolean properties:
 * - `isLocalhost`: True if the hostname is localhost.
 * - `isDev`: True if the environment is development.
 * - `isUat`: True if the environment is UAT.
 * - `isProduction`: True if the environment is production.
 *
 * @example
 * // Example of usage:
 * const { isLocalhost, isDev, isUat, isProduction } = getEnvironment();
 * console.log(isLocalhost); // Logs true if the current environment is `localhost`.
 * console.log(isDev); // Logs true if the current environment is `dev`.
 * console.log(isUat); // Logs true if the current environment is `uat`.
 * console.log(isProduction); // Logs true if the current environment is `prod`.
 */
export function getEnvironment() {
  const isLocalhost = window.location.hostname === Environments.Localhost;
  const isDev = env?.host?.env === Environments.Dev;
  const isUat = env?.host?.env === Environments.Uat;
  const isProduction = env?.host?.env === Environments.Prod;

  return {
    isLocalhost,
    isDev,
    isUat,
    isProduction,
    current: env?.host?.env,
  };
}
